import { useState } from "react";
import Home from "../Home/Home";
import Experience from "../Experience/Experience";
import Skills from "../Skills/Skills";
import Projects from "../Projects/Projects";
import Contact from "../Contact/Contact";
import ThemePicker from "../ThemePicker/ThemePicker";


const LocationIcon = () => (
  <svg aria-hidden="true" height="14" viewBox="0 0 16 16" width="14" style={{ fill: "currentColor", flexShrink: 0 }}>
    <path d="m12.596 11.596-3.535 3.536a1.5 1.5 0 0 1-2.122 0l-3.535-3.536a6.5 6.5 0 1 1 9.192-9.193 6.5 6.5 0 0 1 0 9.193Zm-1.06-8.132v-.001a5 5 0 1 0-7.072 7.072L8 14.07l3.536-3.534a5 5 0 0 0 0-7.072ZM8 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 8 9Z" />
  </svg>
);

const LinkIcon = () => (
  <svg aria-hidden="true" height="14" viewBox="0 0 16 16" width="14" style={{ fill: "currentColor", flexShrink: 0 }}>
    <path d="m7.775 3.275 1.25-1.25a3.5 3.5 0 1 1 4.95 4.95l-2.5 2.5a3.5 3.5 0 0 1-4.95 0 .751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018 2 2 0 0 0 2.83 0l2.5-2.5a2 2 0 0 0-2.83-2.83l-1.25 1.25a.751.751 0 0 1-1.042-.018.751.751 0 0 1-.018-1.042Zm-4.69 9.64a2 2 0 0 0 2.83 0l1.25-1.25a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-1.25 1.25a3.5 3.5 0 1 1-4.95-4.95l2.5-2.5a3.5 3.5 0 0 1 4.95 0 .751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018 2 2 0 0 0-2.83 0l-2.5 2.5a2 2 0 0 0 0 2.83Z" />
  </svg>
);

const TwitterIcon = () => (
  <svg aria-hidden="true" height="14" viewBox="0 0 16 16" width="14" style={{ fill: "currentColor", flexShrink: 0 }}>
    <path d="M9.294 7.23 13.99 1.5h-1.118L8.783 6.463 5.57 1.5H1.8l4.94 7.19L1.8 14.5h1.118l4.319-5.206 3.45 5.206H14.2L9.293 7.23Zm-1.53 1.844-.5-.716L3.332 2.353h1.714l3.213 4.598.5.716 4.177 5.98h-1.714L7.764 9.074Z" />
  </svg>
);

const MailIcon = () => (
  <svg aria-hidden="true" height="14" viewBox="0 0 16 16" width="14" style={{ fill: "currentColor", flexShrink: 0 }}>
    <path d="M1.75 2h12.5c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0 1 14.25 14H1.75A1.75 1.75 0 0 1 0 12.25v-8.5C0 2.784.784 2 1.75 2ZM1.5 12.251c0 .138.112.25.25.25h12.5a.25.25 0 0 0 .25-.25V5.809L8.38 9.397a.75.75 0 0 1-.761 0L1.5 5.809v6.442Zm13-8.181v-.32a.25.25 0 0 0-.25-.25H1.75a.25.25 0 0 0-.25.25v.32L8 7.88Z" />
  </svg>
);

const DownloadIcon = () => (
  <svg aria-hidden="true" height="14" viewBox="0 0 16 16" width="14" style={{ fill: "currentColor", flexShrink: 0 }}>
    <path d="M2.75 14A1.75 1.75 0 0 1 1 12.25v-2.5a.75.75 0 0 1 1.5 0v2.5c0 .138.112.25.25.25h10.5a.25.25 0 0 0 .25-.25v-2.5a.75.75 0 0 1 1.5 0v2.5A1.75 1.75 0 0 1 13.25 14Z" />
    <path d="M7.25 7.689V2a.75.75 0 0 1 1.5 0v5.689l1.97-1.969a.749.749 0 1 1 1.06 1.06l-3.25 3.25a.749.749 0 0 1-1.06 0L4.22 6.78a.749.749 0 1 1 1.06-1.06l1.97 1.969Z" />
  </svg>
);

const RESUME_URL = "https://drive.google.com/file/d/17cJaiaIRWStKxouj_fSKWIutC60ON7Uf/view?usp=sharing";
const GMAIL     = "mailto:akanshabharti1213@gmail.com";
const LINKEDIN  = "https://www.linkedin.com/in/akansha-bharti/";

const GitHubLayout = () => {
  const [activeTab, setActiveTab]       = useState("overview");
  const [mobileProfileOpen, setMobileProfileOpen] = useState(false);

  const tabs = [
    { id: "overview",   label: "Overview"   },
    { id: "projects",   label: "Projects",  count: 8 },
    { id: "experience", label: "Experience", count: 3 },
    { id: "skills",     label: "Skills"     },
    { id: "contact",    label: "Contact"    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "overview":   return <Home onNavigate={setActiveTab} />;
      case "projects":   return <Projects />;
      case "experience": return <Experience />;
      case "skills":     return <Skills />;
      case "contact":    return <Contact />;
      default:           return <Home onNavigate={setActiveTab} />;
    }
  };

  const sidebarLinks = [
    { icon: <LocationIcon />, text: "Delhi, India",                      href: null },
    { icon: <LinkIcon />,     text: "linkedin.com/in/akansha-bharti",    href: LINKEDIN },
    { icon: <TwitterIcon />,  text: "@Akansha_1213",                     href: "https://twitter.com/Akansha_1213" },
    { icon: <MailIcon />,     text: "akanshabharti1213@gmail.com",        href: GMAIL },
  ];

  return (
    <div style={{ background: "var(--gh-bg)", minHeight: "100vh", color: "var(--gh-text)" }}>

      {/* ── Sticky Header ── */}
      <header style={{ background: "var(--gh-surface)", borderBottom: "1px solid var(--gh-border)", position: "sticky", top: 0, zIndex: 100 }}>
        <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 12px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 52 }}>

          {/* Left: logo + breadcrumb */}
          <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
            {/* <GithubOcticon /> */}
            <span style={{ fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              <span style={{ color: "var(--gh-text)", fontWeight: 600 }}>akanshaBharti</span>
              <span style={{ color: "var(--gh-text-secondary)", margin: "0 4px" }}>/</span>
              <span style={{ color: "var(--gh-link)", fontWeight: 600 }} className="">portfolio</span>
            </span>
            <span className="gh-badge gh-badge-blue hide-xs" style={{ fontSize: 11 }}>Public</span>
          </div>

          {/* Right: actions */}
          <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
            <ThemePicker />
            <a
              href={GMAIL}
              className="btn-gh"
              style={{ fontSize: 12, padding: "4px 10px", display: "flex", alignItems: "center", gap: 5, textDecoration: "none" }}
            >
              <MailIcon />
              <span className="hide-xs">Contact</span>
            </a>
            <a
              href={RESUME_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gh-green"
              style={{ fontSize: 12, padding: "4px 10px", display: "flex", alignItems: "center", gap: 5, textDecoration: "none" }}
            >
              <DownloadIcon />
              <span>Resume</span>
            </a>
          </div>
        </div>
      </header>

      {/* ── Mobile Profile Card (shown only on mobile) ── */}
      <div className="mobile-profile-card" style={{ background: "var(--gh-surface)", borderBottom: "1px solid var(--gh-border)", padding: "16px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <img
            src="/assets/PP.png"
            alt="Akansha Bharti"
            style={{ width: 64, height: 64, borderRadius: "50%", objectFit: "cover", objectPosition: "top center", border: "2px solid var(--gh-border)", flexShrink: 0 }}
          />
          <div style={{ flex: 1, minWidth: 0 }}>
            <h1 style={{ fontSize: 17, fontWeight: 600, color: "var(--gh-text)", margin: 0 }}>Akansha Bharti</h1>
            <p style={{ fontSize: 13, color: "var(--gh-text-secondary)", margin: "2px 0 6px" }}>Full Stack Developer · React · Django</p>
            <span className="gh-badge gh-badge-green" style={{ fontSize: 11 }}>
              <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--gh-green)", display: "inline-block" }} />
              Available for work
            </span>
          </div>
          <button
            onClick={() => setMobileProfileOpen(o => !o)}
            style={{ background: "none", border: "1px solid var(--gh-border)", borderRadius: 6, color: "var(--gh-text-secondary)", padding: "4px 8px", cursor: "pointer", fontSize: 18, lineHeight: 1, flexShrink: 0 }}
            aria-label="Toggle profile"
          >
            {mobileProfileOpen ? "▲" : "▼"}
          </button>
        </div>

        {/* Expanded mobile profile */}
        {mobileProfileOpen && (
          <div style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid var(--gh-border)" }}>
            <p style={{ fontSize: 13, color: "var(--gh-text)", marginBottom: 12, lineHeight: 1.6 }}>
              Full Stack Developer focused on React, Python, and Django. Currently Frontend Developer at{" "}
              <a href="https://beyondtax.co/" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gh-link)", textDecoration: "none" }}>@Beyondtax</a>
            </p>
            <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
              <a href={LINKEDIN} target="_blank" rel="noopener noreferrer"
                className="btn-gh" style={{ flex: 1, justifyContent: "center", fontSize: 12, textDecoration: "none" }}>
                Follow on LinkedIn
              </a>
              <a href={GMAIL}
                className="btn-gh-green" style={{ flex: 1, justifyContent: "center", fontSize: 12, textDecoration: "none" }}>
                Hire me
              </a>
            </div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {sidebarLinks.map((item, i) => (
                <li key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, fontSize: 13, color: "var(--gh-text-secondary)" }}>
                  {item.icon}
                  {item.href
                    ? <a href={item.href} target="_blank" rel="noopener noreferrer" style={{ color: "var(--gh-link)", textDecoration: "none", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.text}</a>
                    : <span style={{ color: "var(--gh-text)" }}>{item.text}</span>
                  }
                </li>
              ))}
            </ul>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 5, marginTop: 10 }}>
              {["react", "python", "django", "javascript", "tailwindcss", "full-stack"].map(t => (
                <span key={t} className="gh-topic" style={{ fontSize: 11 }}>{t}</span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* ── Main Layout ── */}
      <main style={{ maxWidth: 1280, margin: "0 auto", padding: "24px 16px" }}>
        <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>

          {/* ── Desktop Sidebar ── */}
          <aside className="desktop-sidebar" style={{ width: 256, flexShrink: 0 }}>

            <div style={{ marginBottom: 16 }}>
              <img
                src="/assets/PP.png"
                alt="Akansha Bharti"
                style={{ width: "100%", maxWidth: 256, aspectRatio: "1", borderRadius: "50%", objectFit: "cover", objectPosition: "top center", border: "2px solid var(--gh-border)", boxShadow: "0 0 0 4px var(--gh-bg)", display: "block" }}
              />
            </div>

            <h1 style={{ fontSize: 24, fontWeight: 600, color: "var(--gh-text)", lineHeight: 1.25, marginBottom: 4 }}>Akansha Bharti</h1>
            <p style={{ fontSize: 20, fontWeight: 300, color: "var(--gh-text-secondary)", marginBottom: 14 }}>akanshaBharti</p>

            <div style={{ marginBottom: 14 }}>
              <span className="gh-badge gh-badge-green animate-pulse-green" style={{ fontSize: 12 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: "var(--gh-green)", display: "inline-block" }} />
                Available for work
              </span>
            </div>

            <p style={{ fontSize: 14, color: "var(--gh-text)", marginBottom: 14, lineHeight: 1.6 }}>
              Full Stack Developer focused on React, Python, and Django. Currently Frontend Developer at{" "}
              <a href="https://beyondtax.co/" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gh-link)", textDecoration: "none" }}>@Beyondtax</a>
            </p>

            <div style={{ display: "flex", gap: 8, marginBottom: 18 }}>
              <a href={LINKEDIN} target="_blank" rel="noopener noreferrer"
                className="btn-gh" style={{ flex: 1, justifyContent: "center", fontSize: 13, textDecoration: "none" }}>
                Follow
              </a>
              <a href={GMAIL}
                className="btn-gh-green" style={{ flex: 1, justifyContent: "center", fontSize: 13, textDecoration: "none" }}>
                Hire me
              </a>
            </div>

            <div style={{ display: "flex", gap: 12, marginBottom: 18, fontSize: 13 }}>
              <span style={{ color: "var(--gh-text)" }}><strong>8</strong> <span style={{ color: "var(--gh-text-secondary)" }}>projects</span></span>
              <span style={{ color: "var(--gh-text)" }}><strong>2.5+</strong> <span style={{ color: "var(--gh-text-secondary)" }}>years exp</span></span>
            </div>

            <ul style={{ listStyle: "none", padding: 0, marginBottom: 18 }}>
              {sidebarLinks.map((item, i) => (
                <li key={i} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, fontSize: 13, color: "var(--gh-text-secondary)" }}>
                  {item.icon}
                  {item.href
                    ? <a href={item.href} target="_blank" rel="noopener noreferrer"
                        style={{ color: "var(--gh-link)", textDecoration: "none", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                        onMouseEnter={e => e.target.style.textDecoration = "underline"}
                        onMouseLeave={e => e.target.style.textDecoration = "none"}>{item.text}</a>
                    : <span style={{ color: "var(--gh-text)" }}>{item.text}</span>
                  }
                </li>
              ))}
            </ul>

            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {["react", "python", "django", "javascript", "tailwindcss", "full-stack"].map(t => (
                <span key={t} className="gh-topic" style={{ fontSize: 11 }}>{t}</span>
              ))}
            </div>
          </aside>

          {/* ── Content Area ── */}
          <div style={{ flex: 1, minWidth: 0 }}>

            {/* Tabs */}
            <div style={{ borderBottom: "1px solid var(--gh-border)", marginBottom: 24 }}>
              <nav className="gh-tab-nav">
                {tabs.map(tab => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`gh-tab${activeTab === tab.id ? " active" : ""}`}
                  >
                    {tab.label}
                    {tab.count !== undefined && (
                      <span className="gh-tab-count">{tab.count}</span>
                    )}
                  </button>
                ))}
              </nav>
            </div>

            <div key={activeTab} className="animate-fadeInUp">
              {renderContent()}
            </div>
          </div>
        </div>
      </main>

      <footer style={{ borderTop: "1px solid var(--gh-card)", marginTop: 40, padding: "14px 16px", textAlign: "center" }}>
        <p style={{ color: "var(--gh-text-muted)", fontSize: 12 }}>
          © 2026 Akansha Bharti · Built with React ·{" "}
          <a href="https://github.com/akanshaBharti" target="_blank" rel="noopener noreferrer" style={{ color: "var(--gh-link)", textDecoration: "none" }}>GitHub</a>
        </p>
      </footer>

      <style>{`
        /* Desktop: hide mobile card */
        .mobile-profile-card { display: none; }
        .desktop-sidebar     { display: block; }

        /* Tablet */
        @media (max-width: 900px) {
          .desktop-sidebar { width: 200px !important; }
        }

        /* Mobile: flip layout */
        @media (max-width: 720px) {
          .mobile-profile-card { display: block; }
          .desktop-sidebar     { display: none !important; }
          .hide-xs             { display: none !important; }
          .gh-tab-nav {
            display: flex !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
          }
          .gh-tab-nav::-webkit-scrollbar { display: none; }
          .gh-tab { padding: 8px 10px !important; font-size: 12px !important; white-space: nowrap; }
        }
      `}</style>
    </div>
  );
};

export default GitHubLayout;
